module.exports = __webpack_public_path__ + "static/media/profile_image_loader.75741e3e.svg";